__turbopack_context__.v({
  "buttonWrapper": "ExtractAvatar-module__qfkAEq__buttonWrapper",
  "hideTextOnMobile": "ExtractAvatar-module__qfkAEq__hideTextOnMobile",
  "offerForm": "ExtractAvatar-module__qfkAEq__offerForm",
  "step": "ExtractAvatar-module__qfkAEq__step",
  "stepDone": "ExtractAvatar-module__qfkAEq__stepDone",
  "stepLabel": "ExtractAvatar-module__qfkAEq__stepLabel",
  "stepLocked": "ExtractAvatar-module__qfkAEq__stepLocked",
  "stepNumber": "ExtractAvatar-module__qfkAEq__stepNumber",
  "stepNumberDone": "ExtractAvatar-module__qfkAEq__stepNumberDone",
  "stepNumberLocked": "ExtractAvatar-module__qfkAEq__stepNumberLocked",
  "steps": "ExtractAvatar-module__qfkAEq__steps",
});
